import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SupportContextService {
  accountId: number | null = null;
  userEmail: string | null = null;

  get isActive(): boolean {
    return this.accountId !== null;
  }

  set(accountId: number, userEmail: string): void {
    this.accountId = accountId;
    this.userEmail = userEmail;
  }

  clear(): void {
    this.accountId = null;
    this.userEmail = null;
  }
}
